import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=c2771d1c&scoped=true"
import script from "./UserLink.vue?vue&type=script&lang=js"
export * from "./UserLink.vue?vue&type=script&lang=js"
import style0 from "./UserLink.vue?vue&type=style&index=0&id=c2771d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2771d1c",
  null
  
)

export default component.exports